moment = require 'moment'

moment.locale 'en-US',
  calendar: require('./english-calendar')
  longDateFormat:
    LT: 'h:mm A'
    LTS: 'h:mm:ss A'
    L: 'MM/DD/YYYY'
    LL: 'MMMM D, YYYY'
    LLL: 'MMMM D, YYYY LT'
    LLLL: 'MMMM D'



// WEBPACK FOOTER //
// ./app/scripts/data/moment/en-US.coffee